import { useEffect, useState } from 'react';

const useDelayUnmount = (isMounted: boolean, delayTime: number) => {
  // Seed from `isMounted` so a consumer that starts already-visible renders on the
  // first frame instead of a blank frame followed by the effect flipping it on.
  const [shouldRender, setShouldRender] = useState(isMounted);

  // Mount synchronously the moment `isMounted` turns true (adjusting state during
  // render, guarded so it runs once) so *showing* never leaves a blank frame while an
  // effect catches up — this is what caused panels to briefly disappear when a step
  // re-entered after unmounting. Only the *unmount* is delayed, via the effect below.
  if (isMounted && !shouldRender) {
    setShouldRender(true);
  }

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (!isMounted && shouldRender) {
      timeoutId = setTimeout(
        () => setShouldRender(false),
        delayTime,
      );
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
};

export default useDelayUnmount;
